import * as React from "react";

export class TeamName extends React.Component<{ name: string, dataUat:string, modifier?: string }, {}> {

    render() {
        return (
            <div data-uat={this.props.dataUat} className={`rj-sports-multiview__team-name ${this.props.modifier ? this.props.modifier : ""}`}>{this.props.name}</div>
        )
    }
}